import React from "react";
import { Typography } from "@mui/material";
import { LocalizedText } from "../i18n/LocalizedText.js";
import { useAutocompleteClasses } from "./Autocomplete.styles.js";
function AutocompletePlaceholder({ emptyPlaceholder }) {
  const { classes: styles } = useAutocompleteClasses();
  return /* @__PURE__ */ React.createElement("div", { className: styles.autocompleteEmptyPlaceholderContainer }, /* @__PURE__ */ React.createElement(Typography, { variant: "body1", color: "secondary", className: styles.autocompleteEmptyPlaceholder }, /* @__PURE__ */ React.createElement(LocalizedText, { label: emptyPlaceholder })));
}
export {
  AutocompletePlaceholder
};
//# sourceMappingURL=AutocompletePlaceholder.js.map
